export const STEP_NAME = 0
export const STEP_PHONE_NUMBER = 1
export const STEP_LINE_REGISTRATION = 2
export const STEP_FINISH = 3
